<template>
  <div>
    <!-- 标题 -->
    <!-- <div>
      <van-nav-bar
        title="社区活动"
      />
    </div> -->
    <!-- tab栏 -->
    <van-sticky>
      <van-tabs @click="onClickOnlyOne"
        color="#fb4d3f"
        title-active-color="#fb4d3f"
        swipeable
        swipe-threshold="4">
        <van-tab v-for="item in TitleList"
          :key="item.AKId"
          :name="item.AKId"
          :title="item.Name">
        </van-tab>
      </van-tabs>
    </van-sticky>

    <div class="information">
      <!-- 全部 -->
      <div class="center borderClass"
        v-for="item in list"
        :key="item.index">
        <router-link :to="'/fivestar/wuXingXq/' + item.AId">

          <div class="Content">
            <div style="display: inline-block; width: 33%"
              class="ContentA"
              ref="getHeight">
              <img v-if="item.AImgUrl"
                style="border-radius:5px;min-height:80px;"
                :src="item.AImgUrl"
                alt="" />
            </div>
            <div style="display: inline-block; width: 63%"
              class="ContentB">
              <div class="centerTitle van-ellipsis--l2">
                {{ item.Title }}
              </div>
              <span class="centertime van-multi-ellipsis--l2"
                style="margin:5px 0px">{{ item.Outline }}</span>
            </div>

            <span class="centertime"
              style="float: right; margin-top: -15px;color:#999999;font-size:11px;">{{
              item.StartTime | timeFilter
            }}</span>
          </div>
        </router-link>
      </div>
      <!-- 没有更多数据了 -->
      <div v-if="hidden"
        class="hidden">───── 没有更多数据了 ─────</div>
    </div>
  </div>
</template>
<script>
import { setOpenId, getOpenId } from "@/utils/auth";
import { WeGetMyActivityPage, WeGetPBActivityPage } from "@/api/RealInfo";
export default {
  data () {
    return {
      akId: 0, //tab栏
      activeName: "",
      list: {}, //资讯列表 
      listfrom: {
        page: 1,
        limit: 99,
        PAKind: 2,
      }, //查询传参
      hidden: true, //没有更多数据了
      TitleList: [],
    };
  },
  filters: {
    timeFilter (value) {
      if (value != undefined) {
        // let gstime = value.replace('T', ' ')
        let gstime = value.substring(0, 10);
        return gstime;
      }
    }
  },
  methods: {
    // 活动分类
    getPBActivityList: function () {
      WeGetPBActivityPage({ PAKind: 2, }).then((res) => {
        this.TitleList = res.data.data;
        if (this.TitleList[0].Children != '0') {
          for (let i = 0; i < this.TitleList.length; i++) {
            const element = this.TitleList[i];
            if (element.Name == '平安法治星') {
              console.log(element);
              this.TitleList = element.Children
              this.listfrom.akId = element.Children[0].AKId
            }
          }
          // this.listfrom.akId = this.TitleList[0].Children[0].AKId
        } else {

        }
        this.getList();
      })
    },
    // 获取分页列表
    getList () {
      WeGetMyActivityPage(this.listfrom)
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.count == 0) {
              this.list = {};
            } else {
              this.list = res.data.data;
              for (var i = 0; i < this.list.length; i++) {
                if (this.list[i].AImgUrl == "") {
                  this.list[i].AImgUrl =
                    "http://cuiyunapi.dexian.ren//upload/images/2021/7/873b94ff-81d.png";
                }
              }
            }
          }
        })
        .catch(() => { });
    },
    topClick: function (name, title) {
      for (let index = 0; index < this.TitleList.length; index++) {
        const element = this.TitleList[index];
        if (element.Children.length != '0') {
          if (element.AKId == name) {
            this.listfrom.akId = element.Children[0].AKId
            this.activeName = element.Children[0].AKId
            this.getList()
          } else {
            this.listfrom.akId = element.AKId
            this.getList()
          }
        }

      }
    },
    // tab点击切换事件
    onClick (name, title) {
      this.list = []
      this.listfrom.akId = name
      this.listfrom.page = 1
      this.getList()
    },
    onClickOnlyOne (name, title) {
      this.list = []
      this.listfrom.akId = name
      this.listfrom.page = 1
      this.getList()
    },
  },
  mounted () {
    if (this.$route.query["openid"]) {
      setOpenId(this.$route.query["openid"]);
    }

    this.getPBActivityList()
  },
};
</script>
<style scoped>
.hidden {
  text-align: center;
  font-size: 12px;
  color: #ccc;
  margin: 10px 0px 25px 0px;
}
.information {
  width: 95%;
  margin: auto;
}
.borderClass {
  padding: 0;
  box-shadow: 0px 5px 17px 1px rgb(0 0 0 / 7%);
}
.borderClass .Content {
  padding: 8px;
  margin-top: 10px;
}
</style>